import { HeaderRow, Row, TableLayout } from "@/app/components/table"
import { getColumns } from "./columns/columns"

export function HeaderContent({
  hideFloorChart = false,
}: { hideFloorChart?: boolean }) {
  const columns = getColumns(false, false, hideFloorChart)
  return (
    <HeaderRow>
      {columns.map((column) => (
        <column.Header key={column.type} />
      ))}
    </HeaderRow>
  )
}

const PLACEHOLDERS = Array.from({ length: 20 }).map((_, idx) => idx)

export function LeaderboardTableLayout({
  children,
  hideFloorChart = false,
}: { children: React.ReactNode; hideFloorChart?: boolean }) {
  return (
    <TableLayout
      header={<HeaderContent hideFloorChart={hideFloorChart} />}
      body={children}
    />
  )
}

export function LeaderboardTableSkeleton({
  hideFloorChart = false,
}: { hideFloorChart?: boolean }) {
  const columns = getColumns(false, false, hideFloorChart)

  return (
    <div className="h-full w-full overflow-auto">
      <LeaderboardTableLayout hideFloorChart={hideFloorChart}>
        {PLACEHOLDERS.map((idx) => (
          <Row key={idx}>
            {columns.map((column) => (
              <column.Cell key={column.type}>
                <div className="p-2">
                  <column.Skeleton />
                </div>
              </column.Cell>
            ))}
          </Row>
        ))}
      </LeaderboardTableLayout>
    </div>
  )
}
